import { createSelector } from 'reselect';
import { serviceProvider } from './serviceProviderSelectors.js';

const stableArray = [];

const formatResponseTimeToMinutes = (time) => {
  if (!time) {
    return null;
  }
  let indexOfPeriod = time.indexOf('.');
  if (indexOfPeriod) {
    time = time.slice(0, indexOfPeriod);
  }

  const split = (time || '').split(':');
  const hours = split[0];

  const minutes = split[1];

  let secondsTime = 0;
  let minutesTime = 0;
  let hoursTime = 0;

  minutesTime = parseInt(minutes);

  hoursTime = parseInt(hours) * 60;

  return secondsTime + minutesTime + hoursTime;
};

// Todo: Temporary fn. Remove after merging response time for chat messages
export const formatResponseTime = (time) => {
  if (!time) {
    return { value: 'N/A' };
  }

  let indexOfPeriod = time.indexOf('.');
  if (indexOfPeriod) {
    time = time.slice(0, indexOfPeriod);
  }

  const split = (time || '').split(':');
  const hours = split[0];
  const minutes = split[1];
  const seconds = split[2];
  const totalMinutes = formatResponseTimeToMinutes(time);
  if (hours === '00' && minutes === '00') {
    return { value: seconds, dataLabel: 'seconds', totalMinutes: 1 };
  }
  if (hours === '00' && minutes !== '00') {
    const minutesToInt = parseInt(minutes);
    return { value: `${minutesToInt}`, dataLabel: 'mins', totalMinutes };
  }
  if (hours !== '00') {
    const hoursToInt = parseInt(hours);
    const minutesToInt = parseInt(minutes);
    if (hoursToInt < 2) {
      return { value: `${totalMinutes}`, dataLabel: 'mins', secondaryValue: minutesToInt, secondaryLabel: 'mins', totalMinutes };
    }
    if (hoursToInt < 48) {
      return { value: `${hoursToInt}`, dataLabel: ` ${hoursToInt === 1 ? 'hr' : 'hrs'}`, secondaryValue: minutesToInt, secondaryLabel: 'mins', totalMinutes };
    }
    let days = (hoursToInt / 24).toFixed(0);

    return { value: `${days}`, dataLabel: 'days', secondaryValue: minutesToInt, secondaryLabel: 'mins', totalMinutes };
  }
  return { value: null, dataLabel: null, secondaryValue: null, secondaryLabel: null };
};

const responseTimeData = (state) => state.insightsReport.responseTimes;
const insightsPipelineLeadData = (state) => state.insightsReport.insightsPipelineLeadData;
const revenueInsights = (state) => state.insightsReport.revenueInsights;

export const responseTimeLocationCount = createSelector(responseTimeData, (data) => {
  return data.filter((n) => n.report_type === 'location');
});

export const locationAndUserResponseTime = createSelector(responseTimeData, (data) => {
  const locations = data.filter((n) => n.report_type === 'location');

  const topLocation = data
    .filter((n) => n.report_type === 'location' && n.business_hours_avg_res)
    .map((n) => ({
      ...n,
      label: n.service_location_name,
      title: 'Fastest Location',
      datapointTitle: n.service_location_name, //
      datapointOne: `${n.event_count} messages`,
      datapointTwo: `${formatResponseTime(n.business_hours_avg_res).value} ${formatResponseTime(n.business_hours_avg_res).dataLabel} avg`,
      totalMinutes: formatResponseTime(n.business_hours_avg_res).totalMinutes,
      xAxisKey: n.report_label,
      selector: 'locationResponseTimes',
      ['Response Time Minutes']: formatResponseTimeToMinutes(n.business_hours_avg_res),
      businessEventAvgResInt: parseInt(n.business_hours_avg_res.replaceAll(':', '').replace('.', '')),
    }))
    .sort((a, b) => a.businessEventAvgResInt - b.businessEventAvgResInt);

  const topUser = data
    .filter((n) => n.report_type === 'user' && n.user_name && n.business_hours_avg_res)
    .map((n) => ({
      ...n,
      label: n.user_name,
      title: 'Fastest User',
      datapointTitle: n.user_name, //
      datapointOne: `${n.event_count} messages`,
      datapointTwo: `${formatResponseTime(n.business_hours_avg_res).value} ${formatResponseTime(n.business_hours_avg_res).dataLabel} avg`,
      totalMinutes: formatResponseTime(n.business_hours_avg_res).totalMinutes,
      xAxisKey: n.user_name,
      selector: 'userResponseTimes',
      businessEventAvgResInt: parseInt(n.business_hours_avg_res.replaceAll(':', '').replace('.', '')),
    }))
    .sort((a, b) => a.totalMinutes - b.totalMinutes);

  const returnData = [];
  if (locations.length > 1 && topLocation[0]) {
    returnData.push(topLocation[0]);
  }
  if (topUser.length && topUser[0]) {
    returnData.push(topUser[0]);
  }

  return returnData;
});

export const userResponseTimes = createSelector(responseTimeData, (data) => {
  const a = data
    .filter((n) => n.report_type === 'user' && n.user_name && n.business_hours_avg_res) //
    .map((n) => ({
      ...n,
      label: n.user_name,
      datapointOne: `${n.event_count} messages`,
      datapointTwo: `${formatResponseTime(n.business_hours_avg_res).value} ${formatResponseTime(n.business_hours_avg_res).dataLabel} avg`,
      totalMinutes: formatResponseTime(n.business_hours_avg_res).totalMinutes,
      ['Response Time']: formatResponseTimeToMinutes(n.business_hours_avg_res),
    }))
    .sort((a, b) => a.totalMinutes - b.totalMinutes);
  return a;
});

export const locationResponseTimes = createSelector(responseTimeData, (data) => {
  return data
    .filter((n) => n.report_type === 'location' && n.business_hours_avg_res)
    .map((n) => ({
      ...n,
      label: n.service_location_name,
      datapointTitle: n.service_location_name, //
      datapointOne: `${n.event_count} messages`,
      datapointTwo: `${formatResponseTime(n.business_hours_avg_res).value} ${formatResponseTime(n.business_hours_avg_res).dataLabel} avg`,
      totalMinutes: formatResponseTime(n.business_hours_avg_res).totalMinutes,
      ['Response Time']: formatResponseTimeToMinutes(n.business_hours_avg_res),
    }))
    .sort((a, b) => a.totalMinutes - b.totalMinutes);
});
export const userResponseTime = createSelector(responseTimeData, (data) => {
  return data
    .filter((n) => n.report_type === 'user' && n.user_name) //
    .map((n) => ({
      ...n,
      ['Response Time']: formatResponseTimeToMinutes(n.business_hours_avg_res),
      datapointTitle: n.user_name,
      datapointOne: `${n.event_count} messages`,
      datapointTwo: `${formatResponseTime(n.business_hours_avg_res).value} ${formatResponseTime(n.business_hours_avg_res).dataLabel} avg`,
      totalMinutes: formatResponseTime(n.business_hours_avg_res).totalMinutes,
    }));
});

export const responseTimeByDayOfWeek = createSelector(responseTimeData, (data) => {
  return data
    .filter((n) => n.report_type === 'day_of_week' && n.day_name) //
    .map((n) => ({
      ...n,
      day: n.day_name.slice(0, 2),
      formattedResponseTime: formatResponseTime(n.business_hours_avg_res ? n.business_hours_avg_res : n.event_avg_res).value ? parseInt(formatResponseTime(n.business_hours_avg_res ? n.business_hours_avg_res : n.event_avg_res).value) : null,
      formattedResponseTimeType: formatResponseTime(n.business_hours_avg_res ? n.business_hours_avg_res : n.event_avg_res).dataLabel,
      formattedResponseTimeOffHours: formatResponseTime(n.off_hours_avg_res ? n.off_hours_avg_res : n.off_hours_avg_res).value ? parseInt(formatResponseTime(n.off_hours_avg_res ? n.off_hours_avg_res : n.off_hours_avg_res).value) : null,
      formattedResponseTimeTypeOffHours: formatResponseTime(n.off_hours_avg_res).dataLabel,
      formattedResponseTimeCountOffHours: n.off_hours_count,

      totalMinutes: formatResponseTime(n.business_hours_avg_res ? n.business_hours_avg_res : n.event_avg_res).totalMinutes,
      isOffHours: n.business_hours_avg_res ? false : true,
    }));
});

export const responseTimeByType = createSelector(responseTimeData, (data) => {
  return data
    .filter((n) => n.report_type === 'type') //
    .map((n) => ({
      ...n,
      data: formatResponseTime(n.business_hours_avg_res),
    }));
});

export const responseTimeTotal = createSelector(responseTimeData, (data) => {
  return data
    .filter((n) => n.report_type === 'totals') //
    .map((n) => ({
      ...n,
      data: formatResponseTime(n.business_hours_avg_res),
    }));
});

export const insightsPrimaryService = createSelector(revenueInsights, (data) => {
  return data
    .filter((n) => n.report_type === 'primary_service') //
    .map((n) => ({
      ...n,
      activeAmountFormatted: n.active_amount //
        ? `$${parseInt(n.won_amount).toLocaleString()}`
        : n.won_amount,
      reportCountFormatted: n.report_count //
        ? parseInt(n.won_count).toLocaleString()
        : n.won_count,
    }));
});

export const insightsTopSources = createSelector(revenueInsights, (data) => {
  return data
    .filter((n) => n.report_type === 'utm_medium_total') //
    .map((n) => ({
      ...n,
      activeAmountFormatted: n.won //
        ? `$${parseInt(n.won_amount).toLocaleString()}`
        : n.won_amount,
      reportCountFormatted: n.won //
        ? parseInt(n.won_count).toLocaleString()
        : n.won_count,
    }));
});

export const userSales = createSelector(revenueInsights, (data) => {
  return data
    .filter((n) => n.report_type === 'user' && n.report_label) //
    .map((n) => ({
      ...n,
      datapointTitle: n.report_label,
      datapointOne: `$${parseInt(n.won_amount).toLocaleString()}`,
      datapointTwo: `${n.won_count}`,
    }))
    .map((n) => {
      return { ...n, Sales: parseInt(n.won_amount) };
    });
});

export const topLocations = createSelector(revenueInsights, (data) => {
  return data
    .filter((n) => n.report_type === 'location' && n.report_label) //
    .map((n) => ({
      ...n,
      datapointTitle: n.report_label,
      datapointOne: `$${parseInt(n.won_amount).toLocaleString()}`,
      datapointTwo: `${n.won_count}`,
    }))
    .map((n) => {
      return { ...n, Sales: parseInt(n.won_amount) };
    });
});

export const leadInsights = createSelector(insightsPipelineLeadData, (data) => {
  return (data || []).filter((n) => n.report_type === 'utm_medium_chart'); //
});

export const leadInsightsTotals = createSelector(insightsPipelineLeadData, (data) => {
  return (data || []).filter((n) => n.report_type === 'total'); //
});

export const totalRevenue = createSelector(revenueInsights, (data) => {
  return (data || []).find((n) => n.report_type === 'total') || {}; //
});

export const leadsByReportLabelEntries = createSelector(leadInsights, (leadInsights) => {
  return Object.entries(
    leadInsights.reduce((a, n) => {
      if (!a[n.report_label]) {
        a[n.report_label] = { count: 0, amount: 0 };
      }
      a[n.report_label].count += parseInt(n.report_count);
      a[n.report_label].amount += parseInt(n.report_value);
      return a;
    }, {})
  ).sort((a, b) => b[1].amount - a[1].amount);
  // .filter((n) => n[1].amount !== 0)
});

export const leadReportPieGraphData = createSelector(leadsByReportLabelEntries, (leadsByReportLabelEntries) => {
  return leadsByReportLabelEntries.map((n) => ({ name: n[0], value: n[1].amount }));
});
